export function displaySkyflowError(errorResponse) {
  if ("error" in errorResponse) {
    let details = errorResponse.error.description ?? "unknown error"
    window.alert(`There was an error saving your data: ${details}`)
  } else {
    if (errorResponse instanceof Error) {
      window.alert(
        `There was an unexpected error saving your data: ` +
          errorResponse.message,
      )
    } else {
      window.alert(
        `There was an unexpected error saving your data: ` +
          JSON.stringify(errorResponse),
      )
    }
  }
}

export function displaySkyflowErrors(errors) {
  const messages = errors.map((e) => {
    if ("error" in e) {
      return e.error.description ?? "unknown error"
    } else if (e instanceof Error) {
      return e.message
    } else {
      return JSON.stringify(e)
    }
  })
  window.alert(
    `There was an error saving your data:\n\n${messages.join("\n\n")}`,
  )
}

export function isSkyflowMissingFileError(errorResponse) {
  if ("error" in errorResponse) {
    let description = errorResponse.error.description
    return (
      description.includes("No files were found") ||
      description.includes("No Files found")
    )
  }
  return false
}
